'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — Mobility owner experience operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Owner & service pulse',
  kpis: [
    { val: '1,360', lbl: 'Live mentions', live: true },
    { val: '92', lbl: 'Open escalations' },
    { val: '3.4m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 37, tone: 'positive' },
    { lbl: 'Neutral', pct: 34, tone: 'neutral' },
    { lbl: 'Negative', pct: 29, tone: 'negative' },
  ],
  sla: { pct: 77, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'A', text: 'Service centre delayed delivery', handle: '@amit_r', tag: 'Service', tagLevel: 'med' },
    { letter: 'N', text: 'Charging issue within a month', handle: '@neha_s', tag: 'Vehicle', tagLevel: 'high' },
    { letter: 'V', text: 'Booking amount not refunded', handle: '@vivek_k', tag: 'Refund', tagLevel: 'med' },
    { letter: 'D', text: 'Switching to another EV brand', handle: '@divya_m', tag: 'Churn', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Churn signal', sub: 'Switch intent rising in forums' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Service case → dealer in 2s' },
  ],
};

export default function MobilityHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Automobile'),
      }}
      title={
        <>
          {t('industries_mobility.the_car_is_built_in_the_factory_the')}{' '}
          <span className="serif-accent italic">{t('industries_mobility.automotive_customer_experience_plat')}</span>
          {' '}{t('industries_mobility.for')}{' '}
          <span className="serif-accent italic">{t('industries_mobility.oems_ev_brands_dealership_networks')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_mobility.the_purchase_decision_happens_onlin')}{' '}
          <span style={BLUE}>{t('industries_mobility.aftersales_complaint')}</span> {t('industries_mobility.that_goes_unanswered_every_unresolv')}{' '}
          <span style={DEEP}>{t('industries_retail_ecommerce.locobuzz_intercepts_all_three')}</span>
        </>
      }
      actions={<BookDemoButton label={t('industries_mobility.book_a_personalised_automotive_cx_d')} />}
      visual={<IndustryCommandCentre ariaLabel="Mobility owner experience command centre" {...CC} />}
    />
  );
}
